import { AdvancedType, BasicType } from '../constants';
import { CUSTOM_LISTING_BLOCK_TYPE } from './listingScope';

export type RootChildRefusal = 'not-wrapper' | 'duplicate-type';

export const ROOT_WRAPPER_MESSAGES: Record<RootChildRefusal, string> = {
	'not-wrapper':
		'A block can only be dropped inside a Wrapper, not on the canvas root.',
	'duplicate-type':
		'A block may contain only one Wrapper of each type. Delete the existing one first.',
};

/**
 * Block editor variant: a block's root holds at most ONE plain Wrapper and at
 * most ONE Custom Listing Wrapper. Outside blockMode, or under any parent other
 * than the Page root, nothing is restricted.
 */
export const canAddRootChild = (params: {
	blockMode?: boolean;
	parentType?: string;
	type: string;
	rootChildren?: Array<{ type: string }>;
}): { ok: true } | { ok: false; reason: RootChildRefusal } => {
	const { blockMode, parentType, type, rootChildren } = params;
	if (!blockMode || parentType !== BasicType.PAGE) return { ok: true };

	const isWrapperType =
		type === AdvancedType.WRAPPER || type === CUSTOM_LISTING_BLOCK_TYPE;
	if (!isWrapperType) return { ok: false, reason: 'not-wrapper' };
	if ((rootChildren || []).some((c) => c.type === type)) {
		return { ok: false, reason: 'duplicate-type' };
	}
	return { ok: true };
};

/** True when `idx` is a direct child of the Page root (e.g. content.children.[1]). */
export const isRootChildIdx = (idx: string): boolean =>
	/^content\.children\.\[\d+\]$/.test(idx);
